import React from 'react';
import { useHistory } from 'react-router-dom';

import makeStyles from '@mui/styles/makeStyles';
import { IconButton } from '@mui/material';

import { getCurrentYear } from '@apps/shared/src/utilities';
import { IncompleteTheme } from './types/theme';

const styles = makeStyles((theme: IncompleteTheme) => ({
  contactUs: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    lineHeight: '1.465rem',
  },
  labelStyle: {
    fontSize: '0.85rem',
    fontWeight: 400,
    color: '#747474',
    borderRadius: 0,
    padding: '0',
    cursor: 'pointer',
    textTransform: 'none',
  },
  copyright: {
    fontWeight: 400,
    fontSize: '0.85rem',
    color: '#888787',
    lineHeight: '1.318rem',
    textAlign: 'center',
  },
  sixDegreeBtn: {
    fontSize: '0.85rem',
    borderRadius: 0,
    padding: '0',
    color: '#F07037',
    textDecoration: 'underline',
    cursor: 'pointer',
    textTransform: 'none',
    verticalAlign: 'baseline',
    minHeight: 0,
    minWidth: 0,
  },
  bottomCredits: {
    bottom: 0,
    width: '100%',
  },
}));
const BottomCredits = () => {
  const classes = styles();
  const history = useHistory();

  return (
    <div className={classes.bottomCredits}>
      <p className={classes.contactUs}>
        <IconButton
          className={classes.labelStyle}
          onClick={() => history.push('/contact-us')}
          size="large"
        >
          Contact Us
        </IconButton>
        <IconButton
          className={classes.labelStyle}
          onClick={() => history.push('/privacy-policy')}
          size="large"
        >
          Privacy Policy
        </IconButton>
        <IconButton
          className={classes.labelStyle}
          onClick={() => history.push('/FAQ')}
          size="large"
        >
          FAQs
        </IconButton>
      </p>
      <p className={classes.copyright}>
        <span>&#169; {getCurrentYear()} </span>
        <IconButton className={classes.sixDegreeBtn} size="large">
          <a
            href="https://www.6degreeshealth.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#F97140' }}
          >
            6 Degrees Health
          </a>
        </IconButton>
        <span> All Rights Reserved</span>
      </p>
    </div>
  );
};

export default BottomCredits;
